/**
 * Navigation Overlay Controller
 * Manages the full-screen navigation menu: open/close toggle,
 * GSAP parallel animations (matching original site behavior),
 * image swap on link hover, and number counter slide.
 * Depends on GSAP being loaded globally.
 */
document.addEventListener('DOMContentLoaded', () => {
    const hamburger = document.querySelector('.navbar_navigation_hamburger');
    const navbarComponent = document.querySelector('.navbar_component');
    const overlay = document.querySelector('.navbar_overlay');
    const revealLayer = document.querySelector('.navbar_reveal_layer');
    const navLinks = document.querySelectorAll('.navbar_link');
    const linkTexts = document.querySelectorAll('.navbar_link_text');
    const images = document.querySelectorAll('.navbar_image');
    const navImages = document.querySelector('.navbar_images');
    const navNumbers = document.querySelector('.navbar_numbers');
    const numbersSlide = document.querySelector('.navbar_numbers_slide');
    const topBar = document.querySelector('.navbar_navigation_hamburger_top');
    const bottomBar = document.querySelector('.navbar_navigation_hamburger_bottom');
    const borderTop = document.querySelector('.borders .border-top');
    const borderLeft = document.querySelector('.borders .border-left');
    const borderRight = document.querySelector('.borders .border-right');
    const borderBottom = document.querySelector('.borders .border-bottom');

    if (!hamburger || !navbarComponent || !overlay) return;

    let isOpen = false;

    /* ── Initial GSAP state ── */
    gsap.set(overlay, { x: '100%', visibility: 'hidden' });
    gsap.set(linkTexts, { x: 100, autoAlpha: 0 });
    if (navNumbers) gsap.set(navNumbers, { autoAlpha: 0 });
    if (navImages) gsap.set(navImages, { autoAlpha: 0 });

    /**
     * Open the navigation overlay.
     * All animations fire in parallel (no timeline).
     */
    function openMenu() {
        isOpen = true;
        navbarComponent.classList.add('is-open');
        hamburger.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        borderTop.style.backgroundColor = 'transparent';
        borderLeft.style.backgroundColor = 'transparent';
        borderRight.style.backgroundColor = 'transparent';
        borderBottom.style.backgroundColor = 'transparent'; 
        if (window.lenis) window.lenis.stop();

        /* Slide overlay panel from right to left */
        gsap.to(overlay, {
            x: '0%',
            visibility: 'visible',
            duration: 1.4,
            ease: 'expo.inOut'
        });

        /* Slide link texts from right to left with stagger */
        gsap.to(linkTexts, {
            x: 0,
            autoAlpha: 1,
            stagger: 0.1,
            duration: 0.9,
            ease: 'power3.out',
            delay: 0.3
        });

        /* Fade in images and numbers */
        gsap.to([navNumbers, navImages].filter(Boolean), {
            autoAlpha: 1,
            duration: 0.6,
            delay: 0.4,
            ease: 'power2.inOut'
        });
    }

    /**
     * Close the navigation overlay.
     * Content slides out to the right first (fast),
     * overlay panel slides out slower — giving the "content leaves, then empty panel slides away" effect.
     */
    function closeMenu() {
        isOpen = false;
        hamburger.classList.remove('is-open');
        document.body.style.overflow = '';
        borderTop.style.backgroundColor = 'var(--color-bg-primary)';
        borderLeft.style.backgroundColor = 'var(--color-bg-primary)';
        borderRight.style.backgroundColor = 'var(--color-bg-primary)';
        borderBottom.style.backgroundColor = 'var(--color-bg-primary)';
        if (window.lenis) window.lenis.start();

        /* Slide link texts out to the right (fast) */
        gsap.to(linkTexts, {
            x: 100,
            autoAlpha: 0,
            duration: 0.4,
            ease: 'power2.in'
        });

        /* Fade out images and numbers (fast) */
        gsap.to([navNumbers, navImages].filter(Boolean), {
            autoAlpha: 0,
            duration: 0.5,
            ease: 'power2.inOut'
        });

        /* Slide overlay panel out to the right (slower, so you see the empty panel sliding) */
        gsap.to(overlay, {
            x: '100%',
            duration: 1.2,
            ease: 'expo.inOut',
            onComplete: () => {
                gsap.set(overlay, { visibility: 'hidden' });
                navbarComponent.classList.remove('is-open');
                if (revealLayer) gsap.set(revealLayer, { x: '100%' });
            }
        });
    }

    /* ── Event: Hamburger click toggles menu ── */
    hamburger.addEventListener('click', (e) => {
        e.preventDefault();
        if (isOpen) {
            closeMenu();
        } else {
            openMenu();
        }
    });

    /* ── Event: Link hover swaps image & slides number ── */
    navLinks.forEach((link) => {
        link.addEventListener('mouseenter', () => {
            const imageId = link.getAttribute('data-image-id');
            if (imageId) {
                images.forEach(img => img.classList.remove('active'));
                const targetImg = document.getElementById(imageId);
                if (targetImg) targetImg.classList.add('active');
            }

            const navIndex = parseInt(link.getAttribute('data-nav-index'), 10);
            if (numbersSlide && !isNaN(navIndex)) {
                numbersSlide.style.transform = `translateY(-${navIndex}em)`;
            }
        });
    });

    /* ── Event: Escape key closes the overlay ── */
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isOpen) {
            closeMenu();
        }
    });
});
